export const timeFormats = {
    nonMilitary: {
        label: "12 Hr",
        value: true
    },
    military: {
        label: "24 Hr",
        value: false
    }
};